import { TileLayer } from "react-leaflet";

/**
 * #1619 (D439) — the tile layer of the new-look maps: it WRAPS, so panning
 * past the date line shows more map, not grey. Its sibling in `Basemaps`
 * (`pages/GroundsMap.jsx`) keeps `noWrap` for every old-look map (#687).
 * Separate file so `GroundsMap.jsx` still renders exactly one `<TileLayer`
 * in source, which `basemap.test.js` pins.
 */
export default function WrappingTileLayer({ attribution, url, maxZoom }) {
  return <TileLayer attribution={attribution} url={url} maxZoom={maxZoom} />;
}
